import { mapState } from 'vuex'
import CashStats from './components/cash-stats/cash-stats.vue'
import PaymentStat from './components/payment-stat/payment-stat.vue'
import IcClear from '@/assets/svg/ic-clear.svg?inline'

export default {
  name: 'StatPanel',
  props: {
    /**
     * Передается из родительского компонента из store,
     * фильтры в store управляют ordersByStatuses
     */
    filterStatus: {
      type: Array,
      default: () => []
    },
    /**
     * Тоже должно быть в store
     */
    ordersByStatuses: {
      type: Object,
      default: () => ({})
    },
    payments: {
      type: Object,
      default: () => ({})
    },
    total: {
      type: Number,
      default: 0
    },
    showCashStats: {
      type: Boolean,
      default: false
    },
    allowedFilters: {
      type: Array
    }
  },
  components: {
    CashStats,
    PaymentStat,
    IcClear
  },
  data() {
    return {
      isWasCancelEncashment: false
    }
  },
  computed: {
    ...mapState({
      sharedOrderStatuses: state => state.sharedData.orderStatuses
    }),
    orderStatuses() {
      if (this.ordersByStatuses) {    
        return Object.keys(this.ordersByStatuses)
        .map(key => {
          return {
            order: this.sharedOrderStatuses[key].order_number,
            status: key,
            name: this.sharedOrderStatuses[key].title,
            value: this.ordersByStatuses[key]
          }
        })
        .sort((a, b) => a.order - b.order)
      }
      return []
    }
  },
  methods: {
    onSelectStatusFilter(statusKey) {
      let statusFilter = [ ...this.filterStatus ]
      const isKeysInFilter = statusFilter.find(sFilter => sFilter === statusKey) !== undefined
      if (isKeysInFilter) {
        statusFilter = statusFilter.filter(sFilter => sFilter !== statusKey)
      } else {
        statusFilter = [...statusFilter, statusKey]
      }
      this.setStatusFilters(statusFilter)
    },
    setStatusFilters(statusFilters) {
      this.$emit('set-filter', [ ...statusFilters ])
    },
    clearStatusFilter() {
      this.setStatusFilters([])
    },
    selectAllFilters() {
      const allStatuses = Object.keys(this.ordersByStatuses)
      const statusesFilter = allStatuses.filter(status => {
        return this.allowedFilters.includes(status)
      })
      this.setStatusFilters(statusesFilter)
    },
    getOptionEnabled(option) {
      if (!this.allowedFilters) {
        return true
      }
      return this.allowedFilters.includes(option.status)
    }
  }
}